function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15mm",
    height: "15mm",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#535353",
      strokeWidth: 0.28649
    },
    d: "M 5.4821575,14.837691 0,14.750901 0.00236999,7.8823719 0.00473999,1.0138434 1.6946992,0.45248532 c 1.4409382,-0.4786402 2.1859227,-0.53295042 5.0557669,-0.3685715 1.8511941,0.1060325 4.3850709,0.3497728 5.6308369,0.5416446 l 2.265032,0.3488578 0.169013,1.49816068 c 0.317661,2.815797 0.20005,11.8489381 -0.159255,12.2316881 -0.201744,0.214907 -0.995311,0.328287 -2.012438,0.287525 C 11.720016,14.95478 8.4973406,14.885431 5.4821533,14.837695 Z M 13.87888,8.0202018 V 1.8683835 L 11.866443,1.5144411 C 10.759602,1.3197727 8.4175409,1.0799156 6.6618622,0.98142522 3.81367,0.82164662 3.3270188,0.86865852 2.1453339,1.4177349 l -1.32438601,0.6153833 0.075286,5.8476837 0.075286,5.8476841 5.27397401,0.15774 c 2.9006861,0.08676 5.8048421,0.186554 6.4536801,0.221768 l 1.179704,0.06402 z M 7.3945233,11.897029 C 7.2968933,11.793028 7.2170177,10.541168 7.2170177,9.1151125 V 6.5222832 L 5.4127629,4.8243883 C 3.8460927,3.3500723 3.1872856,2.3444426 3.7881038,2.3444426 c 0.2284072,0 2.6202414,2.0571864 3.0862928,2.6544809 C 7.1779226,5.3879254 7.431835,5.2087703 8.7407525,3.6820604 9.7617223,2.4912098 10.347297,2.0124224 10.536404,2.2138691 10.725512,2.4153156 10.395796,3.0257441 9.5253394,4.0857345 L 8.2336557,5.6586707 8.1050387,8.7392753 C 7.9844936,11.62654 7.8213315,12.351686 7.3945233,11.897029 Z",
    id: "path2208"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e53d0db09d138217b2286c24fb056ab7.svg";
export { ForwardRef as ReactComponent };